<template>
  <div class="modal workflow-log-modal" v-click-outside="onClose">
    <div class="pull-right">
      <div class="btn-close" @click="onClose"></div>
    </div>
    <div class="content fancy-scroll" @scroll.passive="showScrollbar">
      <div v-if="isLoading" class="content-loading">
        <LoadingSpinner :loadingCaption="'Updates werden geladen...'" />
      </div>
      <div v-else>
        <h2 class="log-modal-title">Änderungen</h2>
        <div v-for="(log, index) in logData" :key="index" class="update-block">
          <div class="user-info">
            <div class="user-details">
              <div class="icon">
                {{ getAuthorName(log.author).substring(0, 1) }}
              </div>
              <div class="author-name">
                <b>{{ getAuthorName(log.author) }}</b>
              </div>
            </div>
            <div class="log-date">
              {{ getFrontDateTimeFormat(log['time-start']) }}
            </div>
          </div>

          <div
            v-for="(updates, i) in log['activity-values']['edits']"
            :key="`updates_${i}`"
          >
            <div
              v-if="updates.key == 'workflow-name-update'"
              class="author-logs"
            >
              <div>-</div>
              <div>
                {{ getAction(updates.key) }} <br />
                <span class="from-wrapper">{{ updates['old-value'] }}</span>
                <template> &rarr; </template>
                <span class="to-wrapper">{{ updates['new-value'] }}</span>
                <br />
              </div>
            </div>

            <div
              v-if="updates.key == 'workflow-task-name-updated'"
              class="author-logs"
            >
              <div>-</div>
              <div>
                {{ getAction(updates.key, ` ${updates.task}`) }}<br />
                <span class="from-wrapper">{{ updates['old-value'] }}</span>
                <template> &rarr; </template>
                <span class="to-wrapper">{{ updates['new-value'] }}</span>
                <br />
              </div>
            </div>

            <div
              v-if="updates.key == 'workflow-task-delete'"
              class="author-logs"
            >
              <div>-</div>
              <div class="from-wrapper">
                {{ getAction(updates.key, ` ${updates.task}`) }}<br />
              </div>
            </div>

            <div v-if="updates.key == 'workflow-task-add'" class="author-logs">
              <div>-</div>
              <div class="to-wrapper">
                {{ getAction(updates.key, ` ${updates.task}`) }}<br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLogs, getUserDataByID } from '../../services/axios/data.api';
import { debouncer } from '../../utils/helpers';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
export default {
  name: 'WorkFlowLogModal',
  props: {
    processId: {
      type: Number | String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      logData: [],
      authorNames: {},
    };
  },
  methods: {
    async getAllAuthorName(logs) {
      try {
        const authors = [...new Set(logs.map((e) => e.author))];
        for (const author of authors) {
          const res = await getUserDataByID(author, 'name');
          if (res && res.status === 200 && res.data) {
            this.authorNames[author] = res.data;
          }
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    getAuthorName(id) {
      if (this.authorNames.hasOwnProperty(id)) return this.authorNames[id];
      else return 'Unknown';
    },
    getAction(key, value = '') {
      const typeToAction = {
        'workflow-name-update': 'Workflowname geändert',
        'workflow-task-name-updated': `Der Name der${value} Aufgabe wurde geändert`,
        'workflow-task-delete': `${value} Aufgabe gelöscht`,
        'workflow-task-add': `${value} Aufgabe hinzugefügt`,
      };
      return typeToAction[key];
    },
    getFrontDateTimeFormat(value) {
      return new Date(parseInt(value)).toLocaleTimeString('de-DE', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        timeZone: 'CET',
      });
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    onClose() {
      this.$emit('onClose');
    },
  },
  async created() {
    if (this.processId) {
      try {
        this.isLoading = true;
        const res = await getLogs(this.processId, 'workflow');

        if (res && res.status === 200 && res.data) {
          if (res?.data?.length && res?.data?.length > 0) {
            this.logData = [...res.data].reverse();
            await this.getAllAuthorName(res.data);
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    }
  },
  components: { LoadingSpinner },
};
</script>
<style scoped>
.modal {
  background: #ffffff;
  border-radius: 0px;
  display: block;
  width: 438px;
  text-align: left;
  font-size: 12px;
  line-height: 17px;
  position: fixed;
  left: unset;
  top: 0;
  right: 0px;
  border-left: 1px solid #dee3e9;
  min-height: fit-content;
  overflow: hidden;
}
.workflow-log-modal .content {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 7px;
  color: #22252b;
  overflow: scroll;
  transition: 0.5s;
  min-height: fit-content;
  height: 100%;
  margin-bottom: 30px;
  height: calc(100vh - 50px);
}

.workflow-log-modal .pull-right {
  position: relative;
  z-index: 3;
  transition: right 0.5s;
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.workflow-log-modal .content-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.workflow-log-modal .log-modal-title {
  font-size: 15px !important;
  letter-spacing: 0.125px;
  font-weight: 500 !important;
  line-height: 40px;
  color: #37352fa6;
  margin-top: 54px;
  margin-bottom: 10px;
}

.workflow-log-modal .update-block .user-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.workflow-log-modal .update-block .user-details {
  display: flex;
  align-items: center;
  gap: 15px;
}

.workflow-log-modal .update-block .icon {
  box-sizing: content-box;
  border: 1px solid currentcolor;
  border-radius: 100%;
  width: 26px;
  height: 26px;
  line-height: 26px;
  overflow: hidden;
  text-align: center;
  font-size: 14px;
  background: white;
  user-select: none;
  color: rgb(55, 53, 47);
  opacity: 1;
}
.workflow-log-modal .update-block .author-name {
  font-size: 15px;
  line-height: 27px;
}
.workflow-log-modal .update-block .author-logs {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 27px;
  margin-top: 25px;
  display: flex;
  gap: 5px;
}
.workflow-log-modal .update-block .author-logs span {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 27px;
}
.workflow-log-modal .update-block .log-date {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}
.workflow-log-modal .update-block .from-wrapper {
  background-color: #fdebec;
}
.workflow-log-modal .update-block .to-wrapper {
  background-color: #edf3ec;
}
.workflow-log-modal .fancy-scroll {
  padding: 0 30px;
}
.workflow-log-modal .update-block {
  padding: 30px 0;
  border-bottom: 1px solid #dee0e4;
}
.workflow-log-modal .update-block:last-child {
  border: none;
}
</style>
